var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatJust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#E7F8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2938_2977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 105,
    height: 105
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 44.27,
    width: 46.5,
    height: 32.1,
    rx: 4.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 80,
    width: 20,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.55,
    y: 50.07,
    width: 8.1,
    height: 8.1,
    rx: 1.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.75,
    y: 63.75,
    width: 21.5,
    height: 7.5,
    rx: 1.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.95,
    y: 50.07,
    width: 8.1,
    height: 8.1,
    rx: 1.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.75,
    y: 49.75,
    width: 7.5,
    height: 21.5,
    rx: 1.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 103.5,
    height: 103.5,
    rx: 51.75,
    stroke: "#0078BB",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2938_2977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 60.5C113 89.4949 89.4949 113 60.5 113C31.5051 113 8 89.4949 8 60.5C8 31.5051 31.5051 8 60.5 8C89.4949 8 113 31.5051 113 60.5Z",
    fill: "url(#paint0_linear_2938_2977)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2938_2977",
    x1: 61,
    y1: -12,
    x2: 60.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatJust);
export default __webpack_public_path__ + "static/media/feat_just.f944e7ab94d35b372b79d22f9ff1ee92.svg";
export { ForwardRef as ReactComponent };